import { render, staticRenderFns } from "./InviteSuppliersDialog.vue?vue&type=template&id=65f6969d&scoped=true"
import script from "./InviteSuppliersDialog.vue?vue&type=script&lang=js"
export * from "./InviteSuppliersDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteSuppliersDialog.vue?vue&type=style&index=0&id=65f6969d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6969d",
  null
  
)

export default component.exports